import { render, staticRenderFns } from "./BackgroundChecks.vue?vue&type=template&id=1bfa0704&scoped=true&lang=pug"
import script from "./BackgroundChecks.vue?vue&type=script&lang=ts"
export * from "./BackgroundChecks.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundChecks.vue?vue&type=style&index=0&id=1bfa0704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa0704",
  null
  
)

export default component.exports